import React, { ComponentProps } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@material-ui/core';

import DialogTitle from './DialogTitle';

export interface ConfirmDialogProps {
  title: string
  message: ComponentProps<any>['children']
  confirmText: string
  cancelText: string
  callback: (confirm: boolean) => void
}

const ConfirmDialog = (props: ConfirmDialogProps) => {
  return (
    <Dialog open={true} onClose={() => props.callback(false)}>
      <DialogTitle onClose={() => props.callback(false)}>{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {props.message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.callback(false)} color="primary">
          {props.cancelText}
        </Button>
        <Button onClick={() => props.callback(true)} color="primary" autoFocus>
          {props.confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;